import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (id) => f3tch(`/crm/tickets/${id}/`).profile(profile()).get();
